export class EntitlementError extends Error {
  constructor(props: string, name = 'EntitlementError') {
    super(props);
    this.name = name;
  }
}
